import {
  CREATE_CERTIFICATE_STUDENT,
  CREATE_CERTIFICATE_STUDENT_FAILED,
  CREATE_CERTIFICATE_STUDENT_SUCCESSFUL,
  DELETE_CERTIFICATE_STUDENT,
  DELETE_CERTIFICATE_STUDENT_FAILED,
  DELETE_CERTIFICATE_STUDENT_SUCCESSFUL,
  GET_CERTIFICATE_STUDENT,
  GET_CERTIFICATE_STUDENT_FAILED,
  GET_CERTIFICATE_STUDENT_SUCCESSFUL,
  UPDATE_CERTIFICATE_STUDENT,
  UPDATE_CERTIFICATE_STUDENT_FAILED,
  UPDATE_CERTIFICATE_STUDENT_SUCCESSFUL,
} from '../../../types/masterclass/certificateStudentTypes';

// get_certificate_student
export const getCertificateStudents = (payload) => {
  return {
    type: GET_CERTIFICATE_STUDENT,
    payload,
  };
};
export const getCertificateStudentsSuccessful = (payload) => {
  return {
    type: GET_CERTIFICATE_STUDENT_SUCCESSFUL,
    payload,
  };
};
export const getCertificateStudentsFailed = (payload) => {
  return {
    type: GET_CERTIFICATE_STUDENT_FAILED,
    payload,
  };
};

// create_certificate_student
export const createCertificateStudent = (payload) => {
  return {
    type: CREATE_CERTIFICATE_STUDENT,
    payload,
  };
};
export const createCertificateStudentSuccessful = (payload) => {
  return {
    type: CREATE_CERTIFICATE_STUDENT_SUCCESSFUL,
    payload,
  };
};
export const createCertificateStudentFailed = (payload) => {
  return {
    type: CREATE_CERTIFICATE_STUDENT_FAILED,
    payload,
  };
};

// update_certificate_student
export const updateCertificateStudent = (payload) => {
  return {
    type: UPDATE_CERTIFICATE_STUDENT,
    payload,
  };
};
export const updateCertificateStudentSuccessful = (payload) => {
  return {
    type: UPDATE_CERTIFICATE_STUDENT_SUCCESSFUL,
    payload,
  };
};
export const updateCertificateStudentFailed = (payload) => {
  return {
    type: UPDATE_CERTIFICATE_STUDENT_FAILED,
    payload,
  };
};

// delete_certificate_student
export const deleteCertificateStudent = (payload) => {
  return {
    type: DELETE_CERTIFICATE_STUDENT,
    payload,
  };
};
export const deleteCertificateStudentSuccessful = (payload) => {
  return {
    type: DELETE_CERTIFICATE_STUDENT_SUCCESSFUL,
    payload,
  };
};
export const deleteCertificateStudentFailed = (payload) => {
  return {
    type: DELETE_CERTIFICATE_STUDENT_FAILED,
    payload,
  };
};
